/* global BigInt */
const units=value=>{const [whole,fraction='']=String(value).split('.');if(!/^\d+$/.test(whole) || !/^\d{0,4}$/.test(fraction))throw new Error('Montant de reçu invalide');return BigInt(whole)*10000n+BigInt(fraction.padEnd(4,'0'));};
const money=value=>`${value/10000n}.${String(value%10000n).padStart(4,'0')}`;
export function receiptData(payout,paymentId){
 const payments=payout.payments || [],index=payments.findIndex(p=>p.id===paymentId);
 if(index<0)throw new Error('Paiement enregistré introuvable');
 const payment=payments[index],paid=payments.slice(0,index+1).reduce((sum,p)=>sum+units(p.amount),0n);
 const net=units(payout.net_payable_amount ?? payout.expected_amount),remaining=net-paid;
 if(remaining<0n)throw new Error('Montants du reçu incohérents');
 return {payment,paid:money(paid),remaining:money(remaining),net:money(net),status:remaining===0n?'Retrait total':'Retrait partiel'};
}

export function mobileReceiptTransaction(payout,paymentId){
 const data=receiptData(payout,paymentId),p=data.payment;
 return {_mobile:true,secret_code:payout.reference,payment_id:p.id,qr_value:JSON.stringify({reference:payout.reference,payment_id:p.id}),
 sender_name:payout.mm_operator || payout.operator || 'Mobile Money',sender_phone:payout.client_phone || '—',
 receiver_name:p.recipient_name || '—',receiver_phone:p.recipient_phone || '—',
 amount:payout.expected_amount,fee:payout.mobile_commission_amount ?? 0,currency:payout.currency,
 status:data.status==='Retrait total'?'paid':'partially_paid',net_payable_amount:data.net,
 paid_total:data.paid,remaining_amount:data.remaining,payment_amount:p.amount,
 last_payment_at:p.paid_at,created_at:p.paid_at,payment_agency:p.agency_id,payment_agent:p.paid_by,note:p.note};
}

export const receiptMoney=(value,currency)=>new Intl.NumberFormat("fr-FR",{minimumFractionDigits:currency==="USD"?2:0,maximumFractionDigits:2}).format(Number(value)).replace(/[\u00a0\u202f]/g,' ');
